import React from 'react'
import { Modal, Button } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { cacheClear } from 'utils/memoryCache'

export default function CompanyBlockedOverlay({ visible, reason, onLogout }) {
  const handleLogout = () => {
    localStorage.removeItem('user')
    cacheClear()
    if (onLogout) onLogout()
    window.location.href = '/login'
  }

  return (
    <Modal
      open={visible}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#ff4d4f', fontSize: 18 }}>
          <ExclamationCircleOutlined />
          <span>Acesso Bloqueado / Suspenso</span>
        </div>
      }
      closable={false}
      keyboard={false}
      maskClosable={false}
      footer={[
        <Button key="logout" onClick={handleLogout}>
          Sair da Conta
        </Button>,
        <Button key="support" type="primary" href={`mailto:${process.env.REACT_APP_SUPORTE_EMAIL || 'gabrielsilva41354@gmail.com'}?subject=Desbloqueio%20de%20Conta`}>
          Falar com Suporte
        </Button>
      ]}
      centered
      width={480}
    >
      <div style={{ fontSize: 15, lineHeight: 1.6, padding: '12px 0' }}>
        <p>
          O acesso da sua empresa a esta plataforma foi suspenso devido a pendências comerciais ou administrativas.
        </p>
        {reason && (
          <div style={{
            background: 'var(--yrm-tint-vermelho)',
            border: '1px solid #ffccc7',
            padding: 12,
            borderRadius: 6,
            marginTop: 12,
            color: '#ff4d4f',
            fontFamily: 'monospace',
            whiteSpace: 'pre-wrap'
          }}>
            <strong>Motivo informado:</strong><br />
            {reason}
          </div>
        )}
        <p style={{ marginTop: 16, fontSize: 13, color: 'var(--yrm-text-3)' }}>
          Caso considere este bloqueio um engano, entre em contato imediatamente com a administração da plataforma para regularizar a situação.
        </p>
      </div>
    </Modal>
  )
}
